import { createFetch } from '@vueuse/core'
import { useAuthenticationStore } from '@/stores/authentication.js'

const useIntelichekFetch = createFetch({
  options: {
    updateDataOnError: true,
    async beforeFetch({ url, options, cancel }) {
      if(!url) cancel();

      const authenticationStore = useAuthenticationStore()
      let authorization
      // If currentUser exists in the auth store, add the token to the auth header
      if (authenticationStore.currentUser && authenticationStore.currentUser.token) {
        // jwt token
        authorization = `Bearer ${authenticationStore.currentUser.token}`
      } else if (authenticationStore.currentUser && authenticationStore.currentUser.api_key) {
        // api key
        authorization = `Bearer ${authenticationStore.currentUser.api_key}`
      }

      options.headers = {
        Authorization: authorization,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }

      return { url, options }
    },
    async afterFetch({ data, response }) {
      if (response.status === 401) {
        const authenticationStore = useAuthenticationStore()
        authenticationStore.unauthenticateUser()
        
        const protectedPaths = ['/my_garage', '/quotes', '/settings', '/profile']
        const currentPath = window.location.pathname
        if (protectedPaths.some(path => currentPath.startsWith(path))) {
          window.location.href = '/'
        }
      }
      return { data, response }
    }
  },
  fetchOptions: {
    mode: 'cors'
  }
})


export {
  useIntelichekFetch
}